import React from "react";
import { ReactComponent as EmailSVG } from "../images/mail_sent.svg";

export default function Success({ response, product }) {
  return (
    <div>
      <div className="flex justify-between">
        <h4 className="text-2xl font-semibold">Success</h4>
      </div>
      <p className="leading-relaxed mt-1 mb-4 text-gray-600">
        Payment of $
        {response.additionalForm
          ? (+response.additionalForm.totalPrice + +product.totalPrice).toFixed(2)
          : product.totalPrice}{" "}
        was successful. You have been emailed a link to download the form.
      </p>
      <EmailSVG className="h-40 mx-auto my-12 container" />
      <br />
      <p className="mb-2">Alternatively, you can download your form here:</p>
      <div className="flex flex-col justify-between mt-2 flex-wrap">
        <a
          href={response.download}
          className="text-white bg-[#005b95] hover:bg-sky-600 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 "
        >
          Download {product.name}
        </a>
      </div>

      {response.additionalForm && (
        <div className="flex flex-col justify-between mt-2 flex-wrap">
          <a
            href={response.additionalForm.download}
            className="text-white bg-[#005b95] hover:bg-sky-600 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 "
          >
            Download {response.additionalForm.formName}
          </a>
        </div>
      )}
      <div className="mt-2">
        <span>Need another form? </span>
        <a
          href="/"
          target="_blank"
          className="no-underline font-semibold hover:underline  hover:text-sky-600 text-[#005b95]"
          rel="noreferrer"
        >
          Click Here
        </a>
      </div>
    </div>
  );
}
